import DropdownButton from "@/components/DropdownButton";
import { useTranslation } from "react-i18next";

interface HistoryDropDownProps {
  id: number;
  hasFirstEvaluationReport: boolean;
  hasSecondEvaluationReport: boolean;
  hasImprovementProposal: boolean;
}

function HistoryDropDown({
  id,
  hasFirstEvaluationReport,
  hasSecondEvaluationReport,
  hasImprovementProposal,
}: HistoryDropDownProps) {
  const { t } = useTranslation();

  return (
    <DropdownButton
      items={[
        {
          key: "first-evaluation-report",
          item: t("evaluation-report"),
          hide: !hasFirstEvaluationReport,
          onClick: async () => {
            window.open(
              `/console/assessment-results/${id}?isFirstTime=true`,
              "_blank",
            );
          },
        },
        {
          key: "improvement-proposal",
          item: t("improvement-proposal"),
          hide: !hasImprovementProposal,
          onClick: async () => {
            window.open(`/console/improvement-proposals/${id}`, "_blank");
          },
        },
        {
          key: "second-evaluation-report",
          item: t("re-assessment-report"),
          hide: !hasSecondEvaluationReport,
          onClick: async () => {
            window.open(
              `/console/assessment-results/${id}?isFirstTime=false`,
              "_blank",
            );
          },
        },
      ]}
    />
  );
}

export default HistoryDropDown;
